import { Button as ButtonAntd } from 'antd';
import { ButtonProps } from 'antd/lib/button';
import styled, { css } from 'styled-components';

interface ExtendedButtonProps extends ButtonProps {
  variant?: 'default' | 'text';
  size?: ButtonProps['size'];
}

const ReportButton = styled(ButtonAntd).attrs<ExtendedButtonProps>(
  ({ variant = 'default', size = 'large' }) => ({
    type: variant === 'default' ? 'default' : 'text',
    size,
  }),
)<ExtendedButtonProps>`
  ${({ variant = 'default' }) =>
    variant === 'default' &&
    css`
      color: #e8630b;
      border: 1px solid #e8630b;
      gap: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      :hover,
      :focus,
      :active {
        color: #e8630b;
        border: 1px solid #e8630b;
      }

      &:disabled {
        color: #bdbdbd;
        border: 1px solid #bdbdbd;

        :hover,
        :active {
          border: 1px solid #bdbdbd;
        }
      }
    `}

  ${({ variant }) =>
    variant === 'text' &&
    css`
      color: #e8630b;
      border: none;
      background-color: transparent;
      gap: 12px;
      display: flex;
      align-items: center;
      justify-content: center;

      :hover,
      :focus,
      :active {
        color: #d75207;
        border: none;
        background-color: #f2f2f2;
      }

      &:disabled {
        color: #bdbdbd;
        border: none;
        background-color: transparent;

        :hover,
        :active {
          border: none;
          background-color: transparent;
        }
      }
    `}
`;

export default ReportButton;
